export const FIELDS_MAPPING = {
  addressee: 'Ship-to name',
  callback_phone_number: 'Contact phone',
  city: 'City',
  cms_id: 'Property ID',
  comments: 'Notes',
  country: 'Country',
  email: 'Contact email',
  group: 'Property',
  locality: 'City',
  lrc3200_quantity: 'Quantity',
  name: 'Property Name',
  postal_code: 'Zip',
  purchase_quantity: 'Quantity',
  region: 'State',
  replacement_quantity: 'Quantity',
  street_address: 'Street address',
};
